import postQuizOne from './postQuizOne';
// import postQuizTwo from './postQuizTwo';
// import postQuizThree from './postQuizThree';

export default {
  title: 'Post Quiz',
  children: [
    postQuizOne,
    // postQuizTwo,
    // postQuizThree
  ]
};



// WEBPACK FOOTER //
// ./src/data/Post-Quiz/index.js